export default "<app-calendario\n  [service]=\"service\"\n  [tipologia]=\"'B'\"\n></app-calendario>\n";